import { makeQuery } from 'shared/utilities';
import { ICommentModel } from 'shared/models';

export type CommentSavePayload = {
    entityType?: string,
    entityId?: number,
    commentId?: number | null,
    id?: number | null,
    value?: string,
    url?: string,
    commentMentions?: ICommentModel['commentMentions'],
    newFiles?: File[],
    clearFiles?: string[],
};

type ResponseType = {
    item: ICommentModel;
};

export const commentsSaveQuery = async function (payload: CommentSavePayload) {
    const { newFiles = [], clearFiles = [], ...comment } = payload;
    if (comment.entityType !== 'TaskTrackerTask') {
        return await makeQuery<ResponseType>('/comments/save', { json: comment });
    }

    const formData = new FormData();
    const fields = {
        id: comment.id,
        entity_type: comment.entityType,
        entity_id: comment.entityId,
        comment_id: comment.commentId,
        value: comment.value,
        url: comment.url,
    };
    Object.entries(fields).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            formData.append(key, String(value));
        }
    });
    comment.commentMentions?.forEach((mention, index) => {
        if (mention.userId !== undefined) {
            formData.append(`comment_mentions[${index}][user_id]`, String(mention.userId));
        }
        if (mention.userName !== undefined) {
            formData.append(`comment_mentions[${index}][user_name]`, mention.userName);
        }
    });
    newFiles.forEach(file => formData.append('files[]', file));
    clearFiles.forEach(file => formData.append('clear_files[]', file));

    return await makeQuery<ResponseType>('/comments/save', { formData });
}
